import React, {Component} from 'react';
import Header from './sub-components/header/Header';
import Sider from './sub-components/sider/Sider';
import ExperienceSummary from './sub-components/experience-summary/ExperienceSummary';
import SkillsSummary from './sub-components/skills-summary/SkillsSummary';
import EducationSummary from './sub-components/education-summary/EducationSummary';

export default class Main extends Component {

    render() {

        return (
            <div className="main">
                <Header />

                <div className="main-body row">
                    <Sider />

                    <div className="col rl" >
                        <ExperienceSummary />

                        <SkillsSummary />

                        <EducationSummary />
                    </div>
                </div>
            </div>
        );
    }
}
